import { requestInFlight, requestSuccess, requestError } from '../actions';
import { getLessonPlan } from 'api/lesson-planner';
import { Dispatch } from 'redux';
import { fillDayGaps } from 'util/lesson-plan-util';

export const fetchLessonPlan = (productCurriculumId?) => {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(requestInFlight());
    const {
      app: { currentWorkbook, selectedClassroomId, locale }
    } = await getState();

    const params = {
      productCurriculumId: productCurriculumId || currentWorkbook?.products[0].productCurriculumId,
      ...(selectedClassroomId && { classroomId: selectedClassroomId })
    };

    try {
      const response = await getLessonPlan(params);
      return await dispatch(
        requestSuccess({
          lessonPlan: { ...response.data, lessons: fillDayGaps(response.data.lessons, locale) }
        })
      );
    } catch (err) {
      dispatch(requestError(err));
    }
  };
};

export const fetchLessonPlanWithAssignments = classroomId => {
  return async (dispatch: Dispatch, getState: () => any) => {
    dispatch(requestInFlight());
    const {
      app: { currentWorkbook, locale }
    } = await getState();

    const params = {
      productCurriculumId: currentWorkbook?.products[0].productCurriculumId,
      ...(classroomId && { classroomId })
    };

    try {
      const response = await getLessonPlan(params);
      return await dispatch(
        requestSuccess({
          lessonPlan: { ...response.data, lessons: fillDayGaps(response.data.lessons, locale) }
        })
      );
    } catch (err) {
      dispatch(requestError(err));
    }
  };
};
